export default {
    "permission_to_entity_matrix": {
        "see": {
            "card": "comment.type_card_see",
            "card_element": "comment.type_element_see"
        }
    },
    "attachments": {
        "extensions": []
    },
    "is_auto_send_comment_on_blur": true
}